import styled from 'styled-components';
import LeftArrowNewIconHome from '../assets/hotels/home/arrow-left-1.svg';

const LeftArrowNewIcon = styled(LeftArrowNewIconHome as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.blue};
  margin: ${props => props.margin};
  cursor: ${props => props.disabled ? '' : 'pointer'};
`;

export default LeftArrowNewIcon;
